// @ts-nocheck
import cuttingInstructionsReducer, {
    CuttingInstructionsActions,
} from "@store/Framework/Store/Store/Data/CuttingInstructions/CuttingInstructionsReducer";
import invoicesReducer, { InvoicesActions } from "@store/Framework/Store/Store/Data/Invoices/InvoicesReducer";
import { combineReducers } from "redux";

const dataReducers = combineReducers({
    cuttingInstructions: cuttingInstructionsReducer,
    invoices: invoicesReducer,
});

export type DataActions = CuttingInstructionsActions | InvoicesActions;

export default dataReducers;
